export const consultation_issues = [
    { value: 'ambulatoire', label: 'Retour à domicile' },
    { value: 'reference', label: 'Référé / transféré' },
    { value: 'contre_avis', label: 'Départ contre avis médical' },
    { value: 'depart_anticipe', label: 'Départ avant la fin de la consultation' },
    { value: 'deces', label: 'Décès' }
]
export const clinical_evolutions = [
    { value: 'gueri', label: 'Guéri' },
    { value: 'ameliore', label: 'Amélioré' },
    { value: 'inchange', label: 'Inchangé' },
    { value: 'aggrave', label: 'Aggravé' },
    { value: 'non_evaluable', label: 'Non évaluable / non applicable' }
]
export function issueLabel(value) {
    if (value === 'hospitalisation') return 'Hospitalisation indiquée'
    const option = consultation_issues.find(item => item.value === value)
    return option ? option.label : 'Non renseigné'
}
export function evolutionLabel(value) {
    const option = clinical_evolutions.find(item => item.value === value)
    return option ? option.label : 'Non renseigné'
}
